import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

type WindowType = 'documents' | 'deliveries'; // Tipos de ventanas

@Injectable({ providedIn: 'root' })
export class WindowStateService {
  private isOpen = new BehaviorSubject<boolean>(false);
  private shouldDestroy = new BehaviorSubject<boolean>(false);

  isOpen$ = this.isOpen.asObservable();
  shouldDestroy$ = this.shouldDestroy.asObservable();

    private windowStates = {
    documents: {
      isOpen: new BehaviorSubject<boolean>(false),
      shouldDestroy: new BehaviorSubject<boolean>(false)
    },
    deliveries: {
      isOpen: new BehaviorSubject<boolean>(false),
      shouldDestroy: new BehaviorSubject<boolean>(false)
    }
  };

   // Observables para documentos
  documentsWindow = {
    isOpen$: this.windowStates.documents.isOpen.asObservable(),
    shouldDestroy$: this.windowStates.documents.shouldDestroy.asObservable()
  };

  // Observables para entregas
  deliveriesWindow = {
    isOpen$: this.windowStates.deliveries.isOpen.asObservable(),
    shouldDestroy$: this.windowStates.deliveries.shouldDestroy.asObservable()
  };

   openWindow(type: WindowType) {
    this.windowStates[type].isOpen.next(true);
    this.windowStates[type].shouldDestroy.next(false);
  }

  closeWindow(type: WindowType, destroy: boolean = true) {
    this.windowStates[type].isOpen.next(false);
    if (destroy) {
      this.windowStates[type].shouldDestroy.next(true);
    }
  }

  // Método genérico si necesitas cerrar todas las ventanas
  closeAllWindows() {
    Object.keys(this.windowStates).forEach(key => {
      this.closeWindow(key as WindowType, true);
    });
  }


  // openWindow() {
  //   this.isOpen.next(true);
  //   this.shouldDestroy.next(false); // Evita destrucción al abrir
  // }

  // closeWindow(destroy: boolean = true) {
  //   this.isOpen.next(false);
  //   if (destroy) {
  //     this.shouldDestroy.next(true); // Forza destrucción al cerrar
  //   }
  // }
}